import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { createI18n } from 'vue-i18n';
import { loadFonts } from './plugins/webfontloader';


loadFonts();

// Import language modules
import en from './locales/en';
import sv from './locales/sv';
import da from './locales/da';
import no from './locales/no';
import fi from './locales/fi';

const messages = {
  en,
  sv,
  da,
  no,
  fi,
};

// Create the i18n instance
const i18n = createI18n({
  legacy: false,
  locale: 'da',
  fallbackLocale: 'en',
  messages,
});

async function initializeApp() {
  try {
    console.log('Fetching settings...');

      // Få sprog fra localstorage. Hvis det er der, så brug det, ellers brug standard sprog fra settings
      const storedLanguage = localStorage.getItem('language') || 'en';
      if (storedLanguage) {
        i18n.global.locale.value = storedLanguage; // Set the locale directly
      }

      // Få hvilket tema (dark eller light) fra localStorage eller settings
      const storedTheme = localStorage.getItem('theme') || 'light';
      const isDarkMode = storedTheme === 'dark';
      localStorage.setItem('theme', storedTheme);
      vuetify.theme.dark = isDarkMode;

    createApp(App)
      .use(i18n)
      .use(router)
      .use(store)
      .use(vuetify)
      .mount('#app');

  } catch (error) {
    console.error('Failed to initialize app:', error);
  }
}

initializeApp();


